module.exports = __webpack_public_path__ + "static/img/no-data.5e5aa49e.png";